import React, { Component } from "react";

export default class Alert extends Component {
  render() {
    const {
      success,
      info,
      warning,
      danger,
      title,
      message,
      close
    } = this.props;
    let _classNames = ["alert", "alert-dismissible"];
    success ? _classNames.push("alert-success") : null;
    info ? _classNames.push("alert-info") : null;
    warning ? _classNames.push("alert-warning") : null;
    danger ? _classNames.push("alert-danger") : null;
    return (
      <div
        className={_classNames.join(" ")}
        role="alert"
        ref={alert => {
          this.element = alert;
        }}
      >
        {close ? (
          <button
            type="button"
            className="close"
            data-dismiss="alert"
            aria-label="Close"
            onClick={() => {
              this.element.remove();
            }}
          >
            <span aria-hidden="true">×</span>
          </button>
        ) : null}
        {title ? <strong>{title}</strong> : null} {message}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/_components/UI/Alert/index.js